import { FREE_PASS_PROMO_ID } from '@/consts/urls';
import { PromoStatuses } from '../types';
import type { Promo } from '../types';

export const selectActivePromo = (promos: Promo[]): Promo | null => {
  if (!FREE_PASS_PROMO_ID) return null;
  return (
    promos.find(
      ({ id, status }) =>
        id === FREE_PASS_PROMO_ID && status === PromoStatuses.Active
    ) ?? null
  );
};
